import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function OtherService() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // زبان از سگمنت اول URL
  const seg = location.pathname.split("/")[1];
  const lang = seg === "fa" || seg === "en" ? seg : "en";

  // انیمیشن ورود
  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const withLang = (to) => `/${lang}${to.startsWith("/") ? to : `/${to}`}`;
  const handleServiceClick = (section) => {
    navigate(withLang(`/service?section=${section}`));
  };

  const cards = [
    {
      key: "historian",
      img: "/assets/offline.png",
      title: t("otherService.cards.historian.title"),
      desc: t("otherService.cards.historian.desc"),
      alt: t("otherService.cards.historian.alt"),
    },
    {
      key: "online",
      img: "/assets/online.png",
      title: t("otherService.cards.online.title"),
      desc: t("otherService.cards.online.desc"),
      alt: t("otherService.cards.online.alt"),
    },
    {
      key: "sms",
      img: "/assets/sms.png",
      title: t("otherService.cards.sms.title"),
      desc: t("otherService.cards.sms.desc"),
      alt: t("otherService.cards.sms.alt"),
    },
    {
      key: "datadiod",
      img: "/assets/diode.png",
      title: t("otherService.cards.datadiod.title"),
      desc: t("otherService.cards.datadiod.desc"),
      alt: t("otherService.cards.datadiod.alt"),
    },
  ];

  return (
    <section
      className="col-xs-12 pl-0 pr-0 pt-5 pb-5 text-center"
      dir={lang === "en" ? "ltr" : "rtl"}
      aria-label={t("otherService.sectionLabel")}
    >
      <h2 className="product-home text-blue1">{t("otherService.title")}</h2>

      <div className="values">
        {cards.map((c, idx) => (
          <div
            key={c.key}
            className={`box fade-in from-bottom delay-${Math.min(idx + 1, 4)}`}
            onClick={() => handleServiceClick(c.key)}
            style={{ cursor: "pointer" }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) =>
              (e.key === "Enter" || e.key === " ") && handleServiceClick(c.key)
            }
            aria-label={`${c.title} — ${t("otherService.open")}`}
          >
            <img
              src={c.img}
              alt={c.alt}
              className="img-responsive center-block"
              loading="lazy"
            />
            <h3 className="fade-in from-bottom delay-2">{c.title}</h3>
            <p className="fade-in from-bottom delay-3">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
